import {Inline, Text} from 'epic-fortnite-react';
import React from 'react';

import {ModerationStatus as ModerationStatusType} from '../../../server/handlers/creative-form/creative.types';

export const ModerationStatus = ({
  moderationStatus,
  text,
}: {
  moderationStatus: ModerationStatusType;
  text: string;
}) => {
  switch (moderationStatus) {
    case 'PENDING':
      return (
        <Inline gap="2xs">
          <Text color="#FF6305" size="sm" transform="uppercase">
            {text}
          </Text>
          <svg
            width="24"
            height="24"
            fill="#FF6305"
            xmlns="http://www.w3.org/2000/svg"
            style={{margin: '-6px'}}>
            <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"></path>
          </svg>
        </Inline>
      );
    case 'APPROVED':
      return (
        <Inline gap="2xs">
          <Text color="green" size="sm" transform="uppercase">
            {text}
          </Text>
          <svg
            width="24"
            height="24"
            fill="green"
            xmlns="http://www.w3.org/2000/svg"
            style={{margin: '-6px'}}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
          </svg>
        </Inline>
      );
    case 'DENIED':
      return (
        <Inline gap="2xs">
          <Text color="red" size="sm" transform="uppercase">
            {text}
          </Text>
          <svg
            width="24"
            height="24"
            fill="red"
            xmlns="http://www.w3.org/2000/svg"
            style={{margin: '-6px'}}>
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
          </svg>
        </Inline>
      );
    default:
      return null;
  }
};
